export default "https://statics.cloudfastin.top/static/v1.27.18.3/store/images/aa.png?653476db7fd048c15cff9ed39f9b6cfa";